import { useRef } from 'react';
import forms from 'src/resources/forms.json';
import AppModal from 'src/components/modal';
import { FormLayoutBuilder, getFormData } from '@pihealth/common-ui-library';
import { useUser } from 'src/components/hooks/useUser';
import { useAppSelector } from 'src/store/hooks';
import { Typography } from '@mui/material';

export default function ESignConsentReAuth({ openSignConsent, setOpenSignConsent, handleConfirmSign }: any) {
  const { loginUserName } = useUser();
  const formGroup = forms.ESignConsentReAuth;
  const codelistData: any = useAppSelector(state => state.codelistData.codeListObjData);
  const { formFields, defaultValues, rules } = getFormData(formGroup.groups, codelistData);
  const initialValues = { ...defaultValues, user_name: loginUserName };
  const { groups } = formFields;
  const formRef: any = useRef(null);

  const handleSubmit = () => {
    formRef.current.submit(handleConfirmSign);
  };

  return (
    <AppModal
      open={openSignConsent}
      title={formGroup.header}
      saveButton={'Confirm'}
      closeButton={'Cancel'}
      handleSubmit={handleSubmit}
      handleClose={() => setOpenSignConsent(false)}
      maxWidth="540px"
    >
      <Typography variant="body1" mb={1.5}>
        By signing this document with an electronic signature, I agree that this is a valid representation of my
        signature.
      </Typography>
      <FormLayoutBuilder initialValues={initialValues} rules={rules} ref={formRef} groups={groups} columnSpacing={2} />
    </AppModal>
  );
}
